import { Outside, Popover, UIText1, Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatbotDesktopMenu.css';
import { ChatbotMenuPinFilter } from './ChatbotMenuPinFilter/ChatbotMenuPinFilter';
import { IChatbotActionButtonSchema } from '../../types/chatbot';

type TProps = {
  isOpen: boolean;
  toggleMenu: () => void;
  actionButtons: IChatbotActionButtonSchema[];
  onItemClick(actionButtonChatbot: IChatbotActionButtonSchema): void;
  disabled: boolean;
  menuText: string;
};

export const ChatbotDesktopMenu: React.FC<TProps> = ({
  isOpen,
  toggleMenu,
  actionButtons,
  onItemClick,
  disabled,
  menuText,
}) => {
  const contentRef = React.useRef<HTMLUListElement>(null);
  const buttonRef = React.useRef<HTMLUListElement>(null);

  const handleClick = React.useCallback(
    (e: React.SyntheticEvent<HTMLLIElement>) => onItemClick(actionButtons[Number(e.currentTarget.dataset.index)]),
    [actionButtons, onItemClick],
  );

  return (
    <Popover
      placement="top-start"
      open={isOpen}
      content={
        <Outside onOutside={toggleMenu} active insideRefs={[contentRef, buttonRef]}>
          <div className={styles['container']}>
            {menuText && <ChatbotMenuPinFilter menuText={menuText} />}
            <ul ref={contentRef} className={styles['list']} data-name="ChatbotMenu_list">
              {actionButtons.map(({ text }, index) => (
                <li
                  key={`chatbot-menu-item-${index}`}
                  className={styles['item']}
                  onClick={handleClick}
                  data-index={index}
                >
                  <UIText1>{text}</UIText1>
                </li>
              ))}
            </ul>
          </div>
        </Outside>
      }
    >
      <span ref={buttonRef} className={styles['button']}>
        <Button disabled={disabled} theme="fill_primary" onClick={toggleMenu} data-name="ChatbotMenu_button">
          Меню
        </Button>
      </span>
    </Popover>
  );
};
